import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';

export interface UserCredentialsDialogData {
  title: string;
  message?: string;
  accountId: string;
  temporaryPassword: string;
}

@Component({
  selector: 'app-user-credentials-dialog',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    MatTooltip,
  ],
  templateUrl: './user-credentials-dialog.component.html',
  styleUrl: './user-credentials-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCredentialsDialogComponent {
  protected readonly dialogRef = inject(MatDialogRef<UserCredentialsDialogComponent>);
  protected readonly data = inject<UserCredentialsDialogData>(MAT_DIALOG_DATA);
  private readonly _clipboard = inject(Clipboard);
  private readonly _snackBar = inject(MatSnackBar);

  protected copyToClipboard(value: string, label: string): void {
    const success = this._clipboard.copy(value);

    if (success) {
      this._snackBar.open(`${label} gekopieerd naar klembord`, undefined, {
        duration: 2000,
      });
    }
  }
}
